export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            了解麻花影视的初心与使命
          </p>
        </div>
        <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            麻花影视致力于为广大影视爱好者提供一站式聚合观影服务。我们聚合<strong>神马影视</strong>、<strong>樱花影视</strong>、<strong>小小影视</strong>、<strong>久久影视</strong>、<strong>飘花影视</strong>、<strong>丫丫影视</strong>、<strong>琪琪影视</strong>、<strong>蚂蚁影视</strong>等多家主流平台的优质资源，通过智能匹配技术为用户推荐最佳播放源，让每一位用户都能享受高清流畅的观影体验。平台每日持续更新，覆盖电影、电视剧、动漫、综艺等全品类内容，是您追剧观影的首选助手。
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/50">
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">8+</div>
              <div className="text-xs text-foreground-500 mt-1">聚合平台</div>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">10万+</div>
              <div className="text-xs text-foreground-500 mt-1">小时资源</div>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">500+</div>
              <div className="text-xs text-foreground-500 mt-1">日均更新</div>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">100%</div>
              <div className="text-xs text-foreground-500 mt-1">免费观看</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}